document.addEventListener('DOMContentLoaded', function () {
    var content = document.getElementById('c111');

    if (!content) {
        return;
    }

    Array.from(content.getElementsByTagName('p')).forEach(function (paragraph) {
        paragraph.classList.add('bodytext');
    });
});
